/* Saved product references only. Shopify remains the source of product data. */
(function (global) {
  'use strict';
  const STORAGE_KEY = 'yulfish:shopify:favorites:v1', MAXIMUM = 100;
  function normalizeEntries(value) {
    if (!Array.isArray(value)) return [];
    const result = [], seen = new Set();
    for (const entry of value) {
      if (!entry || typeof entry !== 'object') continue;
      const handle = typeof entry.handle === 'string' ? entry.handle.trim() : '';
      const variantId = typeof entry.variantId === 'string' || typeof entry.variantId === 'number' ? String(entry.variantId) : '';
      if (!/^[\p{L}\p{N}][\p{L}\p{N}_-]{0,254}$/u.test(handle) || !/^[1-9]\d{0,19}$/.test(variantId)) continue;
      const key = handle + ':' + variantId;
      if (seen.has(key)) continue;
      seen.add(key); result.push({handle, variantId});
      if (result.length === MAXIMUM) break;
    }
    return result;
  }
  function imageUrl(value, base) {
    if (typeof value !== 'string' || !value) return '';
    try {
      const url = new URL(value.startsWith('//') ? 'https:' + value : value, base);
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
    } catch { return ''; }
  }
  async function mapLimit(items, limit, worker) {
    const output = new Array(items.length); let index = 0;
    await Promise.all(Array.from({length:Math.min(Math.max(1, limit), items.length)}, async () => {
      while (index < items.length) { const current = index++; output[current] = await worker(items[current], current); }
    }));
    return output;
  }
  if (typeof module === 'object' && module.exports) module.exports = {normalizeEntries, imageUrl, mapLimit};
  if (!global.document || global.YulFishFavorites) return;
  const document = global.document, config = global.YulFishShopify || {};
  const strings = config.strings?.favorites || {};
  const t = (key, values = {}) => String(strings[key] || key).replace(/\{\{?\s*(\w+)\s*\}?\}/g, (match, name) => values[name] ?? match);
  let root = '/';
  try { const url = new URL(config.root || global.Shopify?.routes?.root || '/', global.location.origin); if (url.origin === global.location.origin) root = url.pathname.replace(/\/?$/, '/'); } catch { /* Keep the same-origin root. */ }
  const keyOf = entry => entry.handle + ':' + entry.variantId;
  const read = () => { try { return normalizeEntries(JSON.parse(global.localStorage.getItem(STORAGE_KEY) || '[]')); } catch { return []; } };
  let entries = read(), live = null, queued = false;
  const pageStates = new WeakMap();
  function announce(message) {
    if (!live) { live = document.createElement('p'); live.className = 'visually-hidden'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); live.setAttribute('aria-atomic', 'true'); document.body.append(live); }
    live.textContent = ''; queueMicrotask(() => { live.textContent = message; });
  }
  function currentEntry(button) {
    const form = button.form || button.closest('form') || button.closest('[data-yf-product]')?.querySelector('[data-yf-add-form]');
    const variantId = form?.querySelector('[name="id"]')?.value || button.dataset.variantId;
    return normalizeEntries([{handle:button.dataset.productHandle, variantId}])[0] || null;
  }
  function syncButtons() {
    const keys = new Set(entries.map(keyOf));
    document.querySelectorAll('[data-yf-save-product]').forEach(button => {
      const entry = currentEntry(button), saved = entry ? keys.has(keyOf(entry)) : false;
      const text = t(saved ? 'remove' : 'save');
      button.setAttribute('aria-pressed', String(saved)); button.setAttribute('aria-label', text);
      button.disabled = !entry;
      let label = button.querySelector('[data-yf-save-label]') || button.querySelector('span');
      if (!label) { label = document.createElement('span'); label.dataset.yfSaveLabel = ''; button.append(label); }
      if (label.textContent !== text) label.textContent = text;
    });
  }
  function commit(next) {
    const normalized = normalizeEntries(next);
    try { global.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized)); }
    catch { announce(t('storage_error')); return false; }
    entries = normalized; syncButtons(); return true;
  }
  function node(tag, className, text) {
    const element = document.createElement(tag); if (className) element.className = className;
    if (text !== undefined) element.textContent = String(text); return element;
  }
  function money(cents, page) {
    const currency = page.dataset.currency || config.currency;
    try { return new Intl.NumberFormat(config.locale || document.documentElement.lang || 'es', {style:'currency', currency}).format(Number(cents) / 100); }
    catch { return (Number(cents) / 100).toFixed(2) + (currency ? ' ' + currency : ''); }
  }
  function card(item, page) {
    const {entry, product, variant} = item, href = root + 'products/' + encodeURIComponent(entry.handle) + '?variant=' + encodeURIComponent(entry.variantId);
    const article = node('article', 'product-card yf-shopify-product-card yf-shopify-favorite-card');
    article.dataset.favoriteKey = keyOf(entry);
    const photo = node('a', 'yf-shopify-card-photo'); photo.href = href; photo.setAttribute('aria-label', product.title || '');
    const source = variant.featured_image?.src || variant.featured_image?.url || (typeof variant.featured_image === 'string' ? variant.featured_image : '') || product.featured_image;
    const src = imageUrl(source, global.location.href);
    if (src) { const image = node('img'); image.src = src; image.alt = ''; image.loading = 'lazy'; image.decoding = 'async'; image.width = 600; image.height = 600; photo.append(image); }
    else photo.append(node('span', 'yf-shopify-photo-empty', t('no_image')));
    const info = node('div', 'yf-shopify-card-info'), name = node('a', 'yf-shopify-card-title', product.title || ''); name.href = href; info.append(name);
    if (variant.title && variant.title !== 'Default Title') info.append(node('p', 'yf-shopify-favorite-option', variant.title));
    const price = node('div', 'yf-shopify-card-price', money(variant.price, page)); info.append(price);
    if (Number(variant.compare_at_price) > Number(variant.price)) price.append(node('s', '', money(variant.compare_at_price, page)));
    if (variant.available === false) info.append(node('p', 'yf-shopify-card-status', t('sold_out')));
    const actions = node('div', 'yf-shopify-favorite-actions'), view = node('a', 'yf-shopify-card-link', t('view')); view.href = href;
    const remove = node('button', 'yf-shopify-favorite-remove', t('remove')); remove.type = 'button'; remove.dataset.yfSaveProduct = ''; remove.dataset.productHandle = entry.handle; remove.dataset.variantId = entry.variantId; remove.setAttribute('aria-pressed', 'true');
    actions.append(view, remove); info.append(actions); article.append(photo, info); return article;
  }
  function restorePageFocus(page, grid, focusIndex, count) {
    if (focusIndex === null || document.activeElement && document.activeElement !== document.body) return;
    const retry = page.querySelector('[data-yf-favorites-error]')?.hidden ? null : page.querySelector('[data-yf-favorites-retry]');
    const target = grid.querySelectorAll('[data-yf-save-product]')[Math.min(focusIndex, count - 1)] || retry || page.querySelector('[data-yf-favorites-title]');
    target?.focus({preventScroll:true});
  }
  async function renderPage(page, focusIndex = null) {
    const previous = pageStates.get(page); previous?.controller.abort();
    const controller = new AbortController(), state = {controller}; pageStates.set(page, state);
    const grid = page.querySelector('[data-yf-favorites-grid]'), empty = page.querySelector('[data-yf-favorites-empty]'), status = page.querySelector('[data-yf-favorites-status]'), error = page.querySelector('[data-yf-favorites-error]');
    const snapshot = entries.slice(), cache = new Map();
    error.hidden = true; empty.hidden = true; status.hidden = false; status.textContent = t('loading'); page.setAttribute('aria-busy', 'true');
    if (!snapshot.length) { grid.replaceChildren(); grid.hidden = true; empty.hidden = false; status.hidden = true; page.removeAttribute('aria-busy'); restorePageFocus(page, grid, focusIndex, 0); return; }
    const results = await mapLimit(snapshot, 4, async entry => {
      try {
        if (controller.signal.aborted) return {cancelled:true};
        if (!cache.has(entry.handle)) cache.set(entry.handle, global.fetch(root + 'products/' + encodeURIComponent(entry.handle) + '.js', {credentials:'same-origin', cache:'no-store', signal:controller.signal}).then(async response => {
          if (response.status === 404 || response.status === 410) return null;
          if (!response.ok) throw new Error('Product request failed');
          const product = await response.json(); if (!product || !Array.isArray(product.variants)) throw new Error('Invalid product response'); return product;
        }));
        const product = await cache.get(entry.handle);
        if (!product) return {missing:entry};
        const variant = product.variants.find(value => String(value.id) === entry.variantId);
        // Avoid deleting a reference if an API response may have truncated a large product.
        if (!variant && product.variants.length >= 250) return {error:true};
        if (!variant) return {missing:entry};
        if (!Number.isFinite(Number(variant.price))) throw new Error('Invalid product price');
        return {entry, product, variant};
      } catch (failure) { return controller.signal.aborted ? {cancelled:true} : {error:true}; }
    });
    if (controller.signal.aborted || pageStates.get(page) !== state || !page.isConnected) return;
    const missing = new Set(results.filter(result => result.missing).map(result => keyOf(result.missing)));
    if (missing.size && commit(entries.filter(entry => !missing.has(keyOf(entry))))) announce(t('unavailable_removed'));
    const cards = results.filter(result => result.product && result.variant);
    grid.replaceChildren(...cards.map(item => card(item, page))); grid.hidden = !cards.length;
    global.YulFishCommerce?.fitTitles?.(grid);
    const failed = results.some(result => result.error);
    error.hidden = !failed; empty.hidden = cards.length > 0 || failed; status.hidden = true; page.removeAttribute('aria-busy'); syncButtons();
    restorePageFocus(page, grid, focusIndex, cards.length);
  }
  function initializePages() {
    document.querySelectorAll('[data-yf-favorites]').forEach(page => { if (!pageStates.has(page)) renderPage(page); });
  }
  function scheduleSync() {
    if (queued) return; queued = true;
    queueMicrotask(() => { queued = false; syncButtons(); initializePages(); });
  }
  document.addEventListener('click', event => {
    const retry = event.target.closest('[data-yf-favorites-retry]');
    if (retry) { renderPage(retry.closest('[data-yf-favorites]'), document.activeElement === retry ? 0 : null); return; }
    const button = event.target.closest('[data-yf-save-product]'); if (!button) return;
    event.preventDefault(); const entry = currentEntry(button); if (!entry) return;
    // Read again so another tab cannot silently overwrite a newer selection.
    entries = read(); const saved = entries.some(value => keyOf(value) === keyOf(entry));
    if (!saved && entries.length >= MAXIMUM) { announce(t('limit', {count:MAXIMUM})); return; }
    const page = button.closest('[data-yf-favorites]'), focusIndex = page && document.activeElement === button ? [...page.querySelectorAll('[data-yf-save-product]')].indexOf(button) : null;
    if (commit(saved ? entries.filter(value => keyOf(value) !== keyOf(entry)) : [...entries, entry])) {
      announce(t(saved ? 'removed' : 'saved'));
      document.querySelectorAll('[data-yf-favorites]').forEach(item => renderPage(item, item === page ? focusIndex : null));
    }
  });
  document.addEventListener('change', event => { if (event.target.matches('[name="id"], [data-yf-variant-select]')) scheduleSync(); });
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-yf-favorites]').forEach(page => pageStates.get(page)?.controller.abort()));
  global.addEventListener('storage', event => { if (event.key !== STORAGE_KEY && event.key !== null) return; entries = read(); syncButtons(); document.querySelectorAll('[data-yf-favorites]').forEach(page => renderPage(page)); });
  new MutationObserver(scheduleSync).observe(document.getElementById('app') || document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['data-variant-id']});
  global.YulFishFavorites = Object.freeze({refresh:scheduleSync}); scheduleSync();
})(typeof window === 'object' ? window : globalThis);
